// @flow
export { default } from './MainMobileFooterItem';



// WEBPACK FOOTER //
// ./src/components/main/MainMobileFooterItem/index.js